 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"group-admin":"group-admin","group-agents":"group-agents","group-favorites":"group-favorites","group-landing":"group-landing","group-lives":"group-lives","group-medalib":"group-medalib","group-stars":"group-stars","group-statistics":"group-statistics","lang-countries-de-js":"lang-countries-de-js","lang-countries-es-js":"lang-countries-es-js","lang-countries-fr-js":"lang-countries-fr-js","lang-countries-it-js":"lang-countries-it-js","lang-countries-pt-js":"lang-countries-pt-js","lang-de-js":"lang-de-js","lang-es-js":"lang-es-js","lang-fr-js":"lang-fr-js","lang-it-js":"lang-it-js","lang-pt-js":"lang-pt-js","lang-scat_faq-es-js":"lang-scat_faq-es-js","lang-withdraw-es-js":"lang-withdraw-es-js"}[chunkId]||chunkId) + "." + {"chunk-08b8bf76":"37a558c7","chunk-1defb259":"741bb8c9","chunk-2d0ba822":"745da62e","chunk-2d0f083f":"5852ca53","chunk-2d216214":"521a5112","chunk-2d217a31":"997037eb","chunk-2d21f801":"be10fb5a","chunk-352a5abc":"155840e5","chunk-788bce92":"3168df98","chunk-eb9c70d8":"377852be","group-admin":"14b3d877","group-agents":"f189334e","group-favorites":"9c7762ae","group-landing":"0ff648f2","group-lives":"a3799d72","group-medalib":"4a0bd534","group-stars":"452ef1f5","group-statistics":"4031be91","lang-countries-de-js":"824fcb3d","lang-countries-es-js":"f16d4b98","lang-countries-fr-js":"099b4842","lang-countries-it-js":"2b1c92b1","lang-countries-pt-js":"7e07588f","lang-de-js":"cdc62601","lang-es-js":"7a09da0e","lang-fr-js":"57f0699f","lang-it-js":"c1403e00","lang-pt-js":"8f257d8c","lang-scat_faq-es-js":"fb7bd99c","lang-withdraw-es-js":"810597bf","chunk-715ed568":"9bb4d1a5","chunk-78f5f868":"7500a8a3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-1defb259":1,"chunk-352a5abc":1,"chunk-788bce92":1,"chunk-eb9c70d8":1,"group-admin":1,"group-landing":1,"group-lives":1,"group-statistics":1,"chunk-715ed568":1,"chunk-78f5f868":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"group-admin":"group-admin","group-agents":"group-agents","group-favorites":"group-favorites","group-landing":"group-landing","group-lives":"group-lives","group-medalib":"group-medalib","group-stars":"group-stars","group-statistics":"group-statistics","lang-countries-de-js":"lang-countries-de-js","lang-countries-es-js":"lang-countries-es-js","lang-countries-fr-js":"lang-countries-fr-js","lang-countries-it-js":"lang-countries-it-js","lang-countries-pt-js":"lang-countries-pt-js","lang-de-js":"lang-de-js","lang-es-js":"lang-es-js","lang-fr-js":"lang-fr-js","lang-it-js":"lang-it-js","lang-pt-js":"lang-pt-js","lang-scat_faq-es-js":"lang-scat_faq-es-js","lang-withdraw-es-js":"lang-withdraw-es-js"}[chunkId]||chunkId) + "." + {"chunk-08b8bf76":"31d6cfe0","chunk-1defb259":"f95335ae","chunk-2d0ba822":"31d6cfe0","chunk-2d0f083f":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-2d217a31":"31d6cfe0","chunk-2d21f801":"31d6cfe0","chunk-352a5abc":"5343c210","chunk-788bce92":"bad0d50d","chunk-eb9c70d8":"af014f25","group-admin":"32d34af6","group-agents":"31d6cfe0","group-favorites":"31d6cfe0","group-landing":"b2e18b12","group-lives":"c8daf856","group-medalib":"31d6cfe0","group-stars":"31d6cfe0","group-statistics":"df7f22dc","lang-countries-de-js":"31d6cfe0","lang-countries-es-js":"31d6cfe0","lang-countries-fr-js":"31d6cfe0","lang-countries-it-js":"31d6cfe0","lang-countries-pt-js":"31d6cfe0","lang-de-js":"31d6cfe0","lang-es-js":"31d6cfe0","lang-fr-js":"31d6cfe0","lang-it-js":"31d6cfe0","lang-pt-js":"31d6cfe0","lang-scat_faq-es-js":"31d6cfe0","lang-withdraw-es-js":"31d6cfe0","chunk-715ed568":"8aed5b5f","chunk-78f5f868":"02721a0f"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
